import * as React from 'react'
import RemoveFieldsButton from '../shared/RemoveFieldsButton'
import MinutesPicker from './MinutesPicker'
import HoursPicker from './HoursPicker'
import RemovedField from './RemovedField'
import QuickTimePicker from './QuickTimePicker'
import PlusMinusToggle from './PlusMinusToggle'
import { MachineShape } from '../../api/api_data_types'

type MachineFieldsProps = {
  className: string
  idKey: string
  machineFields: {
    time: number
    machine_id: number
    id: number
    exported: boolean
    _destroy: boolean
  }
  setMachineFields: (machineFields: any) => void
  availableMachines: MachineShape[]
  fieldNameFn: (field: string) => string
  handleRemove: () => void
  showSignControl?: boolean
}

export default function MachineFields(props: MachineFieldsProps) {
  const { className, idKey, machineFields, setMachineFields, availableMachines, fieldNameFn, handleRemove, showSignControl = false } = props

  const machineId = machineFields.machine_id || ''
  const time = machineFields.time || 0
  const exported = machineFields.exported || false
  const signMultiplier = time < 0 ? -1 : 1
  const minutes = Math.abs(time) % 60 || 0
  const hours = Math.floor(Math.abs(time) / 60) || 0
  const fieldId = field => `${idKey}-field-${field}`
  const id = machineFields.id || null

  if (machineFields._destroy === true) {
    return <RemovedField field={machineFields} fieldNameFn={fieldNameFn} />
  }
  return (
    <fieldset className={`position-relative form-fieldset ${className}`}>
      {!exported && <RemoveFieldsButton className="resources-remove-fields-button" handleRemove={handleRemove} />}
      <div className="row">
        <div className="col-12 form-group">
          <label htmlFor={fieldId('machine_id')}>Maskine/udstyr</label>
          <select
            id={fieldId('machine_id')}
            name={fieldNameFn('machine_id')}
            className="form-control resources-machine-machine"
            value={machineId}
            disabled={exported}
            onChange={e => setMachineFields({ ...machineFields, machine_id: e.target.value })}
            required
          >
            <option />
            {availableMachines.map(machine => {
              const { id, name } = machine
              return (
                <option key={id} value={id}>
                  {name}
                </option>
              )
            })}
          </select>
        </div>
      </div>
      <div className="row">
        <QuickTimePicker
          className="col-md-6"
          disabled={exported}
          setTime={time => setMachineFields({ ...machineFields, time: time * signMultiplier })}
        />
        <div className="col-md-6">
          <div className="resources-time-selects">
            <div className="form-group w-100">
              <label>Tid</label>
              <div className="d-flex">
                {showSignControl && (
                  <PlusMinusToggle
                    signMultiplier={signMultiplier}
                    disabled={exported}
                    onSignChange={newSignMultiplier => {
                      const newTime = time === 0 ? newSignMultiplier * 60 : newSignMultiplier * Math.abs(time)
                      setMachineFields({ ...machineFields, time: newTime })
                    }}
                  />
                )}
                <div className="form-group pr-1 time-picker-field">
                  <HoursPicker
                    disabled={exported}
                    hours={hours}
                    setHours={h => setMachineFields({ ...machineFields, time: (h * 60 + minutes) * signMultiplier })}
                    name={fieldNameFn('hours')}
                  />
                </div>

                <div className="form-group pr-1 time-picker-field">
                  <MinutesPicker
                    disabled={exported}
                    minutes={minutes}
                    setMinutes={m => setMachineFields({ ...machineFields, time: (hours * 60 + m) * signMultiplier })}
                    name={fieldNameFn('minutes')}
                  />
                </div>
              </div>
            </div>
            <input type="hidden" disabled={exported} name={fieldNameFn('time')} value={(hours * 60 + minutes) * signMultiplier} />
            {id && <input type="hidden" disabled={exported} name={fieldNameFn('id')} value={id} />}
          </div>
        </div>
      </div>
    </fieldset>
  )
}
